import { defineMessages } from 'react-intl'

import { TriageWords } from '@lyrahealth-inc/shared-app-logic/src/features/searchForCare/constants'

export const TREATMENT_FOCUS_TITLES = defineMessages({
  [TriageWords.ALCOHOL_AND_SUBSTANCE_USE]: {
    defaultMessage: 'Alcohol and substance use',
    description: 'Session note: Treatment focus: Alcohol and substance use',
  },
  [TriageWords.ANGER]: {
    defaultMessage: 'Anger management',
    description: 'Session note: Treatment focus: Managing anger and frustration',
  },
  [TriageWords.ANXIETY]: {
    defaultMessage: 'Anxiety symptoms',
    description: 'Session note: Treatment focus: Feeling anxious, worried, or on edge',
  },
  [TriageWords.ADD_ADHD]: {
    defaultMessage: 'Attention and hyperactivity patterns',
    description: 'Session note: Treatment focus: Attention, focus, or hyperactivity challenges',
  },
  [TriageWords.BEHAVIOR_ISSUES]: {
    defaultMessage: 'Behavioral dysregulation',
    description: 'Session note: Treatment focus: Difficult or hard-to-manage behaviors',
  },
  [TriageWords.BODY_IMAGE_ISSUES]: {
    defaultMessage: 'Body image concerns',
    description: 'Session note: Treatment focus: Body image concerns',
  },
  [TriageWords.BURNOUT]: {
    defaultMessage: 'Burnout',
    description: 'Session note: Treatment focus: Burnout',
  },
  [TriageWords.SERVING_AS_CAREGIVER]: {
    defaultMessage: 'Caregiver burden',
    description: 'Session note: Treatment focus: Stress related to caregiving responsibilities',
  },
  [TriageWords.JOB_CHANGE]: {
    defaultMessage: 'Career transitions',
    description: 'Session note: Treatment focus: Stress related to job or career changes',
  },
  [TriageWords.MAJOR_HEALTH_CONDITIONS]: {
    defaultMessage: 'Chronic or major health conditions',
    description: 'Session note: Treatment focus: Chronic or major health conditions',
  },
  [TriageWords.CHRONIC_PAIN]: {
    defaultMessage: 'Chronic pain',
    description: 'Session note: Treatment focus: Chronic pain',
  },
  [TriageWords.SADNESS]: {
    defaultMessage: 'Depressive symptoms/persistent sadness',
    description: 'Session note: Treatment focus: Ongoing sadness or low mood',
  },
  [TriageWords.DIFFICULTY_CONCENTRATING]: {
    defaultMessage: 'Difficulty concentrating',
    description: 'Session note: Treatment focus: Trouble focusing or paying attention',
  },
  [TriageWords.WORRYING_TOO_MUCH]: {
    defaultMessage: 'Excessive worrying',
    description: 'Session note: Treatment focus: Worrying a lot or having racing thoughts',
  },
  [TriageWords.FATIGUE]: {
    defaultMessage: 'Fatigue and low energy',
    description: 'Session note: Treatment focus: Fatigue and low energy',
  },
  [TriageWords.FEELING_OVERWHELMED]: {
    defaultMessage: 'Feeling overwhelmed',
    description: 'Session note: Treatment focus: Feeling overwhelmed or stretched too thin',
  },
  [TriageWords.GUILT]: {
    defaultMessage: 'Feelings of guilt',
    description: 'Session note: Treatment focus: Strong or frequent feelings of guilt',
  },
  [TriageWords.FERTILITY]: {
    defaultMessage: 'Fertility journeys',
    description: 'Session note: Treatment focus: Emotional impact of fertility journeys',
  },
  [TriageWords.FINANCIAL_WORRIES]: {
    defaultMessage: 'Financial worries',
    description: 'Session note: Treatment focus: Financial worries',
  },
  [TriageWords.GAMBLING]: {
    defaultMessage: 'Gambling behaviors',
    description: 'Session note: Treatment focus: Gambling behaviors',
  },
  [TriageWords.GENDER_IDENTITY]: {
    defaultMessage: 'Gender identity dysphoria',
    description: 'Session note: Treatment focus: Stress or distress related to gender identity',
  },
  [TriageWords.GRIEF_DEATH_LOVED_ONE]: {
    defaultMessage: 'Grief or death of a loved one',
    description: 'Session note: Treatment focus: Grief or death of a loved one',
  },
  [TriageWords.HOPELESSNESS]: {
    defaultMessage: 'Hopelessness',
    description: 'Session note: Treatment focus: Feeling hopeless about the future',
  },
  [TriageWords.IMPOSTER_SYNDROME]: {
    defaultMessage: 'Imposter syndrome',
    description: 'Session note: Treatment focus: Imposter syndrome',
  },
  [TriageWords.INTIMATE_RELATIONSHIPS]: {
    defaultMessage: 'Intimate relationship conflict',
    description: 'Session note: Treatment focus: Conflict or strain in intimate relationships',
  },
  [TriageWords.IRRITABILITY]: {
    defaultMessage: 'Irritability',
    description: 'Session note: Treatment focus: Feeling easily annoyed or short-tempered',
  },
  [TriageWords.LACK_OF_ENJOYMENT]: {
    defaultMessage: 'Lack of enjoyment',
    description: 'Session note: Treatment focus: Feeling less interest or pleasure in activities',
  },
  [TriageWords.TROUBLE_COPING_WITH_CHANGE]: {
    defaultMessage: 'Life transitions',
    description: 'Session note: Treatment focus: Life transitions',
  },
  [TriageWords.LONELINESS]: {
    defaultMessage: 'Loneliness',
    description: 'Session note: Treatment focus: Loneliness',
  },
  [TriageWords.LOW_SELF_ESTEEM]: {
    defaultMessage: 'Low self-esteem',
    description: 'Session note: Treatment focus: Low self-esteem',
  },
  [TriageWords.NERVOUSNESS_OR_FEELING_ON_EDGE]: {
    defaultMessage: 'Nervousness or feeling on edge',
    description: 'Session note: Treatment focus: Feeling nervous, tense, or on edge',
  },
  [TriageWords.OBSESSIVE_THOUGHTS]: {
    defaultMessage: 'Obsessive/compulsive challenges',
    description: 'Session note: Treatment focus: Distressing repetitive thoughts or rituals',
  },
  [TriageWords.PANIC_ATTACKS]: {
    defaultMessage: 'Panic attacks',
    description: 'Session note: Treatment focus: Panic attacks',
  },
  [TriageWords.PARENTING]: {
    defaultMessage: 'Parenting stress',
    description: 'Session note: Treatment focus: Parenting stress',
  },
  [TriageWords.PERFECTIONISM]: {
    defaultMessage: 'Perfectionism challenges',
    description: 'Session note: Treatment focus: Pressure to be perfect or fear of mistakes',
  },
  [TriageWords.PREGNANCY_NEW_CHILD]: {
    defaultMessage: 'Pregnancy/new child adjustment',
    description: 'Session note: Treatment focus: Pregnancy/new child adjustment',
  },
  [TriageWords.RACIAL_STRESS]: {
    defaultMessage: 'Racial stress',
    description: 'Session note: Treatment focus: Racial stress',
  },
  [TriageWords.RELATIONSHIP_ISSUES]: {
    defaultMessage: 'Relationships issues',
    description: 'Session note: Treatment focus: Ongoing relationship concerns or conflicts',
  },
  [TriageWords.RESTLESSNESS]: {
    defaultMessage: 'Restlessness',
    description: 'Session note: Treatment focus: Feeling restless or unable to relax',
  },
  [TriageWords.SELF_HARM]: {
    defaultMessage: 'Self-harm',
    description: 'Session note: Treatment focus: Self-harm thoughts or behaviors',
  },
  [TriageWords.SEPARATION_DIVORCE]: {
    defaultMessage: 'Separation or divorce',
    description: 'Session note: Treatment focus: Coping with separation or divorce',
  },
  [TriageWords.SEXUAL_ORIENTATION]: {
    defaultMessage: 'Sexual orientation stress',
    description: 'Session note: Treatment focus: Stress related to sexual orientation',
  },
  [TriageWords.SLEEP_ISSUES]: {
    defaultMessage: 'Sleep disturbances',
    description: 'Session note: Treatment focus: Trouble falling or staying asleep',
  },
  [TriageWords.AVOIDANCE_SOCIAL]: {
    defaultMessage: 'Social anxiety and avoidance',
    description: 'Session note: Treatment focus: Worry or fear in social situations',
  },
  [TriageWords.THOUGHTS_OF_SUICIDE]: {
    defaultMessage: 'Suicidal thoughts',
    description: 'Session note: Treatment focus: Suicidal thoughts',
  },
  [TriageWords.TRAUMATIC_EXPERIENCES]: {
    defaultMessage: 'Traumatic experiences',
    description: 'Session note: Treatment focus: Traumatic experiences',
  },
  [TriageWords.TROUBLE_COMMUNICATING]: {
    defaultMessage: 'Trouble communicating',
    description: 'Session note: Treatment focus: Trouble communicating',
  },
  [TriageWords.TROUBLE_RELAXING]: {
    defaultMessage: 'Trouble relaxing',
    description: 'Session note: Treatment focus: Trouble relaxing',
  },
  [TriageWords.WORK_CHALLENGES]: {
    defaultMessage: 'Work stress',
    description: 'Session note: Treatment focus: Stress or conflict related to work',
  },
  [TriageWords.WORTHLESSNESS]: {
    defaultMessage: 'Worthlessness',
    description: 'Session note: Treatment focus: Feelings of worthlessness',
  },
  Other: {
    defaultMessage: 'Other',
    description: 'Session note: Treatment focus: Other',
  },
})

export const dsmFifthEditionDiagnoses = [
  'Alcohol Use Disorder, Mild',
  'Alcohol Use Disorder, Moderate',
  'Alcohol Use Disorder, Severe',
  'Cannabis Use Disorder, Mild',
  'Cannabis Use Disorder, Moderate',
  'Cannabis Use Disorder, Severe',
  'Other Hallucinogen Use Disorder, Mild',
  'Other Hallucinogen Use Disorder, Moderate',
  'Other Hallucinogen Use Disorder, Severe',
  'Inhalant Use Disorder, Mild',
  'Inhalant Use Disorder, Moderate',
  'Inhalant Use Disorder, Severe',
  'Opioid Use Disorder, Mild',
  'Opioid Use Disorder, Moderate',
  'Opioid Use Disorder, Severe',
  'Sedative, Hypnotic, or Anxiolytic Use Disorder, Mild',
  'Sedative, Hypnotic, or Anxiolytic Use Disorder, Moderate',
  'Sedative, Hypnotic, or Anxiolytic Use Disorder, Severe',
  'Stimulant Use Disorder, Amphetamine-type substance, Mild',
  'Stimulant Use Disorder, Amphetamine-type substance, Moderate',
  'Stimulant Use Disorder, Amphetamine-type substance, Severe',
  'Stimulant Use Disorder, Cocaine, Mild',
  'Stimulant Use Disorder, Cocaine, Moderate',
  'Stimulant Use Disorder, Cocaine, Severe',
  'Tobacco Use Disorder, Mild',
  'Tobacco Use Disorder, Moderate',
  'Tobacco Use Disorder, Severe',
  'Other',
]
